import NavigationPanel from './NavigationPanel.vue';

export { NavigationPanel };
export default NavigationPanel;
